import { TFunction } from "i18next";

import { HIGH_MILEAGE, LOW_MILEAGE } from "../constants";

export const getMileageWarningTranslation = (mileage: string, t: TFunction) => {
  if (Number(mileage) > HIGH_MILEAGE) {
    return t("vehicle_condition.mileage.error_high");
  } else if (Number(mileage) < LOW_MILEAGE) {
    return t("vehicle_condition.mileage.error_low");
  } else {
    return "";
  }
};
